import { axios } from '@/utils/request'

const api = {
  user: '/user',
  service: '/service',
  permission: '/permission',
  permissionNoPager: '/permission/no-pager',
  orgTree: '/org/tree',
  dishes: '/dishes/index',
  addDishes: '/dishes/create',
  updateDishes: '/dishes/update',
  getDishesUser: '/dishesUser/getDishesUser',
  getQuotations: '/motto/index',
  addQuotations: '/motto/create',
  delQuotations: '/motto/delete',
  getSuggestion: '/suggest/index',
  addSuggestion: '/suggest/deal',
  getBookmarkList: '/bookmark/index',
  getBookmarkCategory: '/bookmarkCategory/index',
  getTool: '/tool/index',
  addTool: '/tool/create',
  delTool: '/tool/delete',
  updateTool: '/tool/update',
  uploadUrl: '/upload/index',
  roleList: '/adminRole/index',
  addRole: '/adminRole/create',
  updateRole: '/adminRole/update',
  delRole: '/adminRole/delete',
  articleCategoryIndex: '/articleCategory/index',
  articleCategoryCreate: '/articleCategory/create',
  articleCategoryUpdate: '/articleCategory/update',
  articleCategoryDelete: '/articleCategory/delete',
  getAdminUrl: '/adminUser/index',
  // createAdminUrl: '/adminUser/create',
  // delAdminUrl: '/adminUser/delete',
  // updateAdminUrl: '/adminUser/update',
  // statusAdminUrl: '/adminUser/updateStatus',
  addBookmark: '/bookmark/create',
  editBookmark: '/bookmark/update',
  removeBookmark: '/bookmark/delete',
  // frontRoleList: '/frontRole/index',
  // addFrontRole: '/frontRole/create',
  // updateFrontRole: '/frontRole/update',
  // delFrontRole: '/frontRole/delete',
  // frontAccessList: '/frontAccess/index',
  // updateFrontAccess: '/frontAccess/update',
  // delFrontAccess: '/frontAccess/delete',
  // addFrontAccess: '/frontAccess/create',
  frontUser: '/frontUser/index',
  delFrontUser: '/frontUser/delete',
  statusFrontUser: '/frontUser/updateStatus',
  departmentList: '/department/index',
  updateForntUser: '/frontUser/update',
  addCategroyBookmark: '/bookmarkCategory/create',
  removeCategroyBookmark: '/bookmarkCategory/delete',
  // delPartmentUrl: '/department/delete',
  // createPartmentUrl: '/department/create',
  // updatePartmentUrl: '/department/update',
  getNoticeList: '/notice/index',
  departmentaPeopleList: '/department/getDepartmentUsers',
  noticePush: '/notice/push',
  newNotice: '/notice/create',
  editNotice: '/notice/update',
  articleList: '/articlePost/index',
  articleCreat: '/articlePost/create',
  removeArticle: '/articlePost/delete',
  uploadArticle: '/articlePost/update',
  sortArticle: '/articlePost/sort',
  powerArticle: '/frontAccess/index',
  updatePowerArticle: '/frontAccess/update',
  updateRoleAuthorize: '/adminRole/authorize',
  adminArticle: '/adminAccess/index',
  editClassBookmark: '/bookmarkCategory/update',
  // getInviteLink: '/frontRole/getInviteLink',
  deleteAnnouncement: '/notice/delete',
  deleteAdminList: '/adminAccess/delete',
  addAdminList: '/adminAccess/create',
  editAdminList: '/adminAccess/update',
  serUpSort: '/tool/sort',
  seleRole: '/frontUser/bindUserRole',
  todoindex: '/todo/index',
  departmentindex: '/department/index',
  bulletChatConfigindex: '/bulletChatConfig/index',
  bulletChatConfigupdate: '/bulletChatConfig/update',
  bulletChatdelete: '/bulletChat/delete',
  bulletChatindex: '/bulletChat/index'
}

export default api

export function getUserList(parameter) {
  return axios({
    url: api.user,
    method: 'get',
    params: parameter
  })
}

export function getServiceList(parameter) {
  return axios({
    url: api.service,
    method: 'get',
    params: parameter
  })
}

export function getPermissions(parameter) {
  return axios({
    url: api.permissionNoPager,
    method: 'get',
    params: parameter
  })
}

export function getOrgTree(parameter) {
  return axios({
    url: api.orgTree,
    method: 'get',
    params: parameter
  })
}

// id == 0 add     post
// id != 0 update  put
export function saveService(parameter) {
  return axios({
    url: api.service,
    method: parameter.id === 0 ? 'post' : 'put',
    data: parameter
  })
}

/**
 * 获取画餐列表
 * @param parameter
 * @returns {*}
 */
export function getDishesList(parameter) {
  return axios({
    url: api.dishes,
    method: 'get',
    params: parameter
  })
}

/**
 * 保存画餐
 * @param parameter
 * @returns {*}
 */
export function saveDishes(parameter) {
  return axios({
    url: parameter.id === '' ? api.addDishes : api.updateDishes,
    method: 'post',
    data: parameter,
    params: { role: parameter.id === '' ? '/admin' + api.addDishes : '/admin' + api.updateDishes }
  })
}

/**
 * 获取画餐人列表
 * @param parameter
 * @returns {*}
 */
export function getDishesUserList(parameter) {
  return axios({
    url: api.getDishesUser,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.getDishesUser }
  })
}

/**
 * 获取微语录列表
 * @param parameter
 * @returns {*}
 */
export function getQuotationsList(parameter) {
  return axios({
    url: api.getQuotations,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.getQuotations }
  })
}

/**
 * 添加微语录
 * @param parameter
 * @returns {*}
 */
export function addQuotations(parameter) {
  return axios({
    url: api.addQuotations,
    method: 'POST',
    data: parameter,
    params: { role: '/admin' + api.addQuotations }
  })
}

/**
 * 删除微语录
 * @param parameter
 * @returns {*}
 */
export function delQuotations(parameter) {
  return axios({
    url: api.delQuotations,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.delQuotations }
  })
}

/**
 * 获取投诉建议列表
 * @param parameter
 * @returns {*}
 */
export function getSuggestionList(parameter) {
  return axios({
    url: api.getSuggestion,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.getSuggestion }
  })
}

/**
 * 提交投诉建议
 * @param parameter
 * @returns {*}
 */
export function addSuggestionInfo(parameter) {
  return axios({
    url: api.addSuggestion,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.addSuggestion }
  })
}

/**
 * 获取书签列表
 * @param parameter
 * @returns {*}
 */
export function getBookmarkList(parameter) {
  return axios({
    url: api.getBookmarkList,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.getBookmarkList }
  })
}

/**
 * 获取分类书签列表
 * @param parameter
 * @returns {*}
 */
export function getBookmarkCategory(parameter) {
  return axios({
    url: api.getBookmarkCategory,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.getBookmarkCategory }
  })
}
/**
 * 新增书签
 * @param parameter
 * @returns {*}
 */
export function addNewBookmark(parameter) {
  return axios({
    url: api.addBookmark,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.addBookmark }
  })
}

/**
 * 编辑书签分类
 * @param parameter
 * @returns {*}
 */
export function editClassBookmark(parameter) {
  return axios({
    url: api.editClassBookmark,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.editClassBookmark }
  })
}

/**
 * 删除书签
 * @param parameter
 * @returns {*}
 */
export function removeBookmark(parameter) {
  return axios({
    url: api.removeBookmark,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.removeBookmark }
  })
}
/**
 * 编辑书签
 * @param parameter
 * @returns {*}
 */
export function editBookmark(parameter) {
  return axios({
    url: api.editBookmark,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.editBookmark }
  })
}
/**
 * 书签分类新增书签
 * @param parameter
 * @returns {*}
 */
export function addCategroyBookmark(parameter) {
  return axios({
    url: api.addCategroyBookmark,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.addCategroyBookmark }
  })
}
/**
 * 删除分类书签
 * @param parameter
 * @returns {*}
 */
export function removeCategroyBookmark(parameter) {
  return axios({
    url: api.removeCategroyBookmark,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.removeCategroyBookmark }
  })
}
/**
 * 获取工具配置列表
 * @param parameter
 * @returns {*}
 */
export function getToolList(parameter) {
  return axios({
    url: api.getTool,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.getTool }
  })
}

/**
 * 编辑工具配置
 * @param parameter
 * @returns {*}
 */
export function updateTool(parameter) {
  return axios({
    url: api.updateTool,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.updateTool }
  })
}

/**
 * 删除工具配置
 * @param parameter
 * @returns {*}
 */
export function delTool(parameter) {
  return axios({
    url: api.delTool,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.delTool }
  })
}

/**
 * 新增工具配置
 * @param parameter
 * @returns {*}
 */
export function createTool(parameter) {
  return axios({
    url: api.addTool,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    params: { role: '/admin' + api.addTool }
  })
}
/**
 * 获取角色列表
 * @param parameter
 * @returns {*}
 */
export function getRoleList(parameter) {
  return axios({
    url: api.roleList,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.roleList }
  })
}

/**
 * 创建角色
 * @param parameter
 * @returns {*}
 */
export function createRole(parameter) {
  return axios({
    url: api.addRole,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.addRole }
  })
}

/**
 * 更新角色
 * @param parameter
 * @returns {*}
 */
export function updateRole(parameter) {
  return axios({
    url: api.updateRole,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.updateRole }
  })
}

/**
 * 删除角色
 * @param parameter
 * @returns {*}
 */
export function delRole(parameter) {
  return axios({
    url: api.delRole,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.delRole }
  })
}

/**
 * 文章分类列表
 * @param parameter
 * @returns {*}
 */
export function getAiticleCategoryList(parameter) {
  return axios({
    url: api.articleCategoryIndex,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.articleCategoryIndex }
  })
}

/**
 * 新增文章分类
 * @param parameter
 * @returns {*}
 */
export function addAiticleCategory(parameter) {
  return axios({
    url: api.articleCategoryCreate,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.articleCategoryCreate }
  })
}

/**
 * 编辑文章分类
 * @param parameter
 * @returns {*}
 */
export function updateAiticleCategory(parameter) {
  return axios({
    url: api.articleCategoryUpdate,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.articleCategoryUpdate }
  })
}

/**
 * 删除文章分类
 * @param parameter
 * @returns {*}
 */
export function delAiticleCategory(parameter) {
  return axios({
    url: api.articleCategoryDelete,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.articleCategoryDelete }
  })
}

// /**
//  * 获取用户角色列表
//  * @param parameter
//  * @returns {*}
//  */
// export function getFrontRoleList (parameter) {
//   return axios({
//     url: api.frontRoleList,
//     method: 'post',
//     data: parameter,
//     params: { 'role': '/admin' + api.frontRoleList }
//   })
// }

// /**
//  * 创建用户角色
//  * @param parameter
//  * @returns {*}
//  */
// export function createFrontRole (parameter) {
//   return axios({
//     url: api.addFrontRole,
//     method: 'post',
//     data: parameter,
//     params: { 'role': '/admin' + api.addFrontRole }
//   })
// }

// /**
//  * 更新用户角色
//  * @param parameter
//  * @returns {*}
//  */
// export function updateFrontRole (parameter) {
//   return axios({
//     url: api.updateFrontRole,
//     method: 'post',
//     data: parameter,
//     params: { 'role': '/admin' + api.updateFrontRole }
//   })
// }

// /**
//  * 删除用户角色
//  * @param parameter
//  * @returns {*}
//  */
// export function delFrontRole (parameter) {
//   return axios({
//     url: api.delFrontRole,
//     method: 'post',
//     data: parameter,
//     params: { 'role': '/admin' + api.delFrontRole }
//   })
// }

// /**
//  * 获取用户权限列表
//  * @param parameter
//  * @returns {*}
//  */
// export function getFrontAccessList (parameter) {
//   return axios({
//     url: api.frontAccessList,
//     method: 'post',
//     data: parameter,
//     params: { 'role': '/admin' + api.frontAccessList }
//   })
// }

// /**
//  * 创建用户权限
//  * @param parameter
//  * @returns {*}
//  */
// export function createFrontAccess (parameter) {
//   return axios({
//     url: api.addFrontAccess,
//     method: 'post',
//     data: parameter,
//     params: { 'role': '/admin' + api.addFrontAccess }
//   })
// }

// /**
//  * 更新用户权限
//  * @param parameter
//  * @returns {*}
//  */
// export function updateFrontAccess (parameter) {
//   return axios({
//     url: api.updateFrontAccess,
//     method: 'post',
//     data: parameter,
//     params: { 'role': '/admin' + api.updateFrontAccess }
//   })
// }

// /**
//  * 删除用户权限
//  * @param parameter
//  * @returns {*}
//  */
// export function delFrontAccess (parameter) {
//   return axios({
//     url: api.delFrontAccess,
//     method: 'post',
//     data: parameter,
//     params: { 'role': '/admin' + api.delFrontAccess }
//   })
// }

/**
 * 获取管理员列表
 * @param parameter
 * @returns {*}
 */
export function getAdminList(parameter) {
  return axios({
    url: api.getAdminUrl,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.getAdminUrl }
  })
}

// /**
//  * 新增管理员
//  * @param parameter
//  * @returns {*}
//  */
// export function createAdminList (parameter) {
//   return axios({
//     url: api.createAdminUrl,
//     method: 'post',
//     data: parameter,
//     params: { 'role': '/admin' + api.createAdminUrl }
//   })
// }

// /**
//  * 编辑管理员
//  * @param parameter
//  * @returns {*}
//  */
// export function updateAdminList (parameter) {
//   return axios({
//     url: api.updateAdminUrl,
//     method: 'post',
//     data: parameter,
//     params: { 'role': '/admin' + api.updateAdminUrl }
//   })
// }

// /**
//  * 删除管理员
//  * @param parameter
//  * @returns {*}
//  */
// export function delAdminList (parameter) {
//   return axios({
//     url: api.delAdminUrl,
//     method: 'post',
//     data: parameter,
//     params: { 'role': '/admin' + api.delAdminUrl }
//   })
// }

// /**
//  * 管理员状态更新
//  * @param parameter
//  * @returns {*}
//  */
// export function statusAdmin (parameter) {
//   return axios({
//     url: api.statusAdminUrl,
//     method: 'post',
//     data: parameter,
//     params: { 'role': '/admin' + api.statusAdminUrl }
//   })
// }

/**

 * 获取用户列表
 * @param parameter
 * @returns {*}
 */
export function frontUserList(parameter) {
  return axios({
    url: api.frontUser,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.frontUser }
  })
}

/**
 * 删除用户列表
 * @param parameter
 * @returns {*}
 */
export function delFrontUserList(parameter) {
  return axios({
    url: api.delFrontUser,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.delFrontUser }
  })
}

/**
 * 用户状态更新
 * @param parameter
 * @returns {*}
 */
export function statusFrontUser(parameter) {
  return axios({
    url: api.statusFrontUser,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.statusFrontUser }
  })
}

/**
 * 获取部门列表
 * @param parameter
 * @returns {*}
 */
export function getDepartmentalList(parameter) {
  return axios({
    url: api.departmentList,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.departmentList }
  })
}

// /**
//  * 删除部门
//  * @param parameter
//  * @returns {*}
//  */
// export function delPartmentList (parameter) {
//   return axios({
//     url: api.delPartmentUrl,
//     method: 'post',
//     data: parameter,
//     params: { 'role': '/admin' + api.delPartmentUrl }
//   })
// }

// /**
//  * 增加部门
//  * @param parameter
//  * @returns {*}
//  */
// export function createPartmentList (parameter) {
//   return axios({
//     url: api.createPartmentUrl,
//     method: 'post',
//     data: parameter,
//     params: { 'role': '/admin' + api.createPartmentUrl }
//   })
// }

// /**
//  * 编辑部门
//  * @param parameter
//  * @returns {*}
//  */
// export function updatePartmentList (parameter) {
//   return axios({
//     url: api.updatePartmentUrl,
//     method: 'post',
//     data: parameter,
//     params: { 'role': '/admin' + api.updatePartmentUrl }
//   })
// }
/**
 * 获取组织成员
 * @param parameter
 * @returns {*}
 */
export function getDepartmentaPeople(parameter) {
  return axios({
    url: api.departmentaPeopleList,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.departmentaPeopleList }
  })
}

/**

 * 编辑用户列表
 * @param parameter
 * @returns {*}
 */
export function updateForntUser(parameter) {
  return axios({
    url: api.updateForntUser,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.updateForntUser }
  })
}

/**
 * 获取公告列表
 * @param parameter
 * @returns {*}
 */
export function NoticeList(parameter) {
  return axios({
    url: api.getNoticeList,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.getNoticeList }
  })
}

/**
 * 推送公告
 * @param parameter
 * @returns {*}
 */
export function NoticePush(parameter) {
  return axios({
    url: api.noticePush,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.noticePush }
  })
}
/**
 * 新增公告
 * @param parameter
 * @returns {*}
 */
export function addNewsNotice(parameter) {
  return axios({
    url: api.newNotice,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.newNotice }
  })
}

/**
 * 编辑公告
 * @param parameter
 * @returns {*}
 */
export function editNotice(parameter) {
  return axios({
    url: api.editNotice,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.editNotice }
  })
}

/**
 * 文章列表
 * @param parameter
 * @returns {*}
 */
export function getArticleList(parameter) {
  return axios({
    url: api.articleList,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.articleList }
  })
}

/**
 * 新增文章
 * @param parameter
 * @returns {*}
 */
export function creatArticle(parameter) {
  return axios({
    url: api.articleCreat,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.articleCreat }
  })
}

/**
 * 批量删除文章
 * @param parameter
 * @returns {*}
 */
export function removeArticle(parameter) {
  return axios({
    url: api.removeArticle,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.removeArticle }
  })
}

/**
 * 修改文章
 * @param parameter
 * @returns {*}
 */
export function uploadArticle(parameter) {
  return axios({
    url: api.uploadArticle,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.uploadArticle }
  })
}

/**
 * 文章批量排序
 * @param parameter
 * @returns {*}
 */
export function sortArticle(parameter) {
  return axios({
    url: api.sortArticle,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.sortArticle }
  })
}

/**
 * 获取用户权限设置列表
 * @param parameter
 * @returns {*}
 */
export function powerArticle(parameter) {
  return axios({
    url: api.powerArticle,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.powerArticle }
  })
}

/**
 * 编辑用户权限设置
 * @param parameter
 * @returns {*}
 */
export function updatePowerArticle(parameter) {
  return axios({
    url: api.updatePowerArticle,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.updatePowerArticle }
  })
}

/**
 * 获取管理员权限设置列表
 * @param parameter
 * @returns {*}
 */
export function adminArticle(parameter) {
  return axios({
    url: api.adminArticle,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.adminArticle }
  })
}
// /**
//  * 获取链接
//  * @param parameter
//  * @returns {*}
//  */
// export function getInviteLink (parameter) {
//   return axios({
//     url: api.getInviteLink,
//     method: 'post',
//     data: parameter,
//     params: { 'role': '/admin' + api.getInviteLink }
//   })
// }

/**
 * 管理员授权
 * @param parameter
 * @returns {*}
 */
export function updateRoleAuthorize(parameter) {
  return axios({
    url: api.updateRoleAuthorize,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.updateRoleAuthorize }
  })
}
/**
 * 删除公告
 * @param parameter
 * @returns {*}
 */
export function deleteAnnouncement(parameter) {
  return axios({
    url: api.deleteAnnouncement,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.deleteAnnouncement }
  })
}

/**
 * 删除管理员权限
 * @param parameter
 * @returns {*}
 */
export function deleteAdminList(parameter) {
  return axios({
    url: api.deleteAdminList,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.deleteAdminList }
  })
}

/**
 * 添加管理员权限
 * @param parameter
 * @returns {*}
 */
export function addAdminList(parameter) {
  return axios({
    url: api.addAdminList,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.addAdminList }
  })
}

/**
 * 编辑管理员权限
 * @param parameter
 * @returns {*}
 */
export function editAdminList(parameter) {
  return axios({
    url: api.editAdminList,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.editAdminList }
  })
}
/**
 * 编辑管理员权限
 * @param parameter
 * @returns {*}
 */
export function sortSetUp(parameter) {
  return axios({
    url: api.serUpSort,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.serUpSort }
  })
}
/**
 * 编辑管理员权限
 * @param parameter
 * @returns {*}
 */
export function userSeleRole(parameter) {
  return axios({
    url: api.seleRole,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.seleRole }
  })
}
/**
 * todolist
 * @param parameter
 * @returns {*}
 */
export function gettodoindex(parameter) {
  return axios({
    url: api.todoindex,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.todoindex }
  })
}
/**
 * 部门列表
 * @param parameter
 * @returns {*}
 */
export function departmentindex(parameter) {
  return axios({
    url: api.departmentindex,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.todoindex }
  })
}
/**
 * 弹幕设置数据
 * @param parameter
 * @returns {*}
 */
export function bulletChatConfigindex(parameter) {
  return axios({
    url: api.bulletChatConfigindex,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.bulletChatConfigupdate }
  })
}
/**
 * 弹幕设置编辑
 * @param parameter
 * @returns {*}
 */
export function bulletChatConfigupdate(parameter) {
  return axios({
    url: api.bulletChatConfigupdate,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.bulletChatConfigupdate }
  })
}
/**
 * 弹幕列表
 * @param parameter
 * @returns {*}
 */
export function bulletChatindex(parameter) {
  return axios({
    url: api.bulletChatindex,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.bulletChatindex }
  })
}
/**
 * 删除弹幕
 * @param parameter
 * @returns {*}
 */
export function bulletChatdelete(parameter) {
  return axios({
    url: api.bulletChatdelete,
    method: 'post',
    data: parameter,
    params: { role: '/admin' + api.bulletChatdelete }
  })
}
